import React from "react";
import styled, { keyframes } from "styled-components";
import { withProps } from "recompose";

import Button from "package-common-react/lib/components/Button";
import RoundedButton from "package-common-react/lib/components/RoundedButton";

import { get, mixin } from "package-common-react/lib/style/util";

import closeIcon from "../../images/close-blue.svg";
import theme from "../../theme";

export const POPIN_DURATION_IN_MS = 350;
const popinClose = keyframes`
  from { transform: translateY(0); opacity: 1 }
  to { transform: translateY(50px); opacity: 0 }
`;
export const Popin = styled(function({ close, className, children }) {
  return (
    <section className={className}>
      {close}
      {React.Children.map(children, child => child)}
    </section>
  );
})`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  background: #fff;
  border-radius: 8px;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  flex: 1;
  left: 0;
  margin: 125px 25px 25px 25px;
  min-height: 400px;
  overflow: auto;
  padding: 25px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;

  &.exited {
    display: none;
  }
  &.exiting {
    overflow: hidden;
    animation: ${popinClose} ${POPIN_DURATION_IN_MS}ms ease;
    animation-fill-mode: forwards;
  }
`;

export const CloseButton = styled(function(props) {
  return <RoundedButton size={30} color={theme.color.red} src={closeIcon} alt="Fermer" {...props} />;
})`
  position: absolute;
  right: 15px;
  top: 15px;
`;

export const Heading = styled.p`
  ${mixin('font.bold', 18)};
  color: ${get('color.red')};
  box-sizing: border-box;
  margin: 0;
  padding: 0 40px 0 0;
  text-align: left;
  width: 100%;
`;

export const Subheading = styled.h2`
  ${mixin('font.bold', 20)};
  color: ${get('color.red')};
  margin: 10px 0;
  padding: 0;
  text-align: left;
  text-transform: uppercase;
`;

export const LinkButton = styled(
  withProps({
    primary: true,
    backgroundColor: "#E40421"
  })(
    Button.withComponent(function({ primary, backgroundColor, children, ...props }) {
      return <a {...props}>{children}</a>;
    })
  )
)`
  margin: 0 auto;
  padding: 10px 20px;
`;

export const ImageLogo = styled(function({ className, ...props }) {
  return (
    <div className={className}>
      <img alt="" {...props} />
    </div>
  );
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 10px 0;

  img {
    height: auto !important;
    max-height: 100%;
    max-width: none !important;
    object-fit: contain;
    width: 100%;
  }
`;

export const ImagePopin = styled(function({ className, ...props }) {
  return (
    <div className={className}>
      <img alt="" {...props} />
    </div>
  );
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 2;
  margin: 10px 0;

  img {
    height: auto !important;
    max-height: 100%;
    max-width: none !important;
    object-fit: contain;
    width: 100%;
  }
`;

export const Footer = styled.div`
  flex: 0;
`;



// WEBPACK FOOTER //
// ./src/components/AdPopin/style.js